{
  "app": {
    "name": "Moubarati",
    "tagline": "Gestion des officiels de football"
  },
  "actions": {
    "save": "Sauvegarder",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "delete": "Supprimer",
    "add": "Ajouter",
    "edit": "Modifier",
    "close": "Fermer",
    "search": "Rechercher",
    "filter": "Filtrer",
    "export": "Exporter",
    "import": "Importer",
    "download": "Télécharger",
    "print": "Imprimer",
    "refresh": "Actualiser",
    "view": "Voir",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "submit": "Soumettre",
    "reset": "Réinitialiser",
    "apply": "Appliquer",
    "clear": "Effacer",
    "select": "Sélectionner",
    "create": "Créer",
    "update": "Mettre à jour",
    "validate": "Valider",
    "reject": "Rejeter",
    "approve": "Approuver",
    "archive": "Archiver",
    "restore": "Restaurer",
    "send": "Envoyer",
    "generate": "Générer",
    "copy": "Copier",
    "paste": "Coller",
    "upload": "Uploader",
    "open": "Ouvrir",
    "expand": "Développer",
    "collapse": "Réduire",
    "more": "Plus",
    "less": "Moins",
    "show_all": "Tout afficher",
    "hide": "Masquer",
    "show": "Afficher",
    "home": "Retour à l'accueil",
    "retry": "Réessayer",
    "ok": "OK",
    "history": "Historique"
  },
  "alert": {
    "why_label": "Pourquoi :",
    "action_label": "Action :"
  },
  "date_placeholder": "JJ/MM/AAAA",
  "datepicker": {
    "select_month": "Sélectionner un mois",
    "select_year": "Sélectionner une année",
    "change_year": "Changer l'année",
    "today": "Aujourd'hui"
  },
  "status": {
    "active": "Actif",
    "inactive": "Inactif",
    "pending": "En attente",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "completed": "Terminé",
    "cancelled": "Annulé",
    "draft": "Brouillon",
    "published": "Publié",
    "suspended": "Suspendu",
    "blocked": "Bloqué",
    "open": "Ouvert",
    "closed": "Fermé",
    "in_progress": "En cours",
    "paid": "Payé",
    "unpaid": "Non payé",
    "partial": "Partiel"
  },
  "labels": {
    "name": "Nom",
    "name_ar": "Nom (Arabe)",
    "first_name": "Prénom",
    "last_name": "Nom de famille",
    "full_name": "Nom complet",
    "email": "Email",
    "phone": "Téléphone",
    "date": "Date",
    "time": "Heure",
    "description": "Description",
    "notes": "Notes",
    "status": "Statut",
    "type": "Type",
    "category": "Catégorie",
    "role": "Rôle",
    "code": "Code",
    "number": "Numéro",
    "amount": "Montant",
    "total": "Total",
    "address": "Adresse",
    "city": "Ville",
    "country": "Pays",
    "region": "Région",
    "created_at": "Créé le",
    "updated_at": "Modifié le",
    "created_by": "Créé par",
    "id": "ID",
    "season": "Saison",
    "league": "Ligue",
    "club": "Club",
    "match": "Match",
    "official": "Officiel",
    "referee": "Arbitre",
    "observer": "Observateur",
    "date_of_birth": "Date de naissance",
    "age": "Âge",
    "gender": "Genre",
    "nationality": "Nationalité",
    "wilaya": "Wilaya",
    "grade": "Grade",
    "level": "Niveau",
    "function": "Fonction",
    "salary": "Salaire",
    "payment": "Paiement",
    "document": "Document",
    "file": "Fichier",
    "image": "Image",
    "logo": "Logo",
    "website": "Site web",
    "comments": "Commentaires",
    "reason": "Motif",
    "source": "Source"
  },
  "boolean": {
    "yes": "Oui",
    "no": "Non",
    "none": "Aucun",
    "all": "Tous",
    "other": "Autre"
  },
  "loading": {
    "loading": "Chargement…",
    "please_wait": "Veuillez patienter…",
    "initializing": "Initialisation de l'application…",
    "loading_settings": "Chargement des paramètres globaux…",
    "saving": "Sauvegarde en cours…",
    "deleting": "Suppression en cours…",
    "sending": "Envoi en cours…",
    "generating": "Génération en cours…",
    "processing": "Traitement en cours…",
    "disconnecting": "Déconnexion en cours…"
  },
  "errors": {
    "generic": "Une erreur est survenue",
    "network": "Erreur réseau. Vérifiez votre connexion.",
    "unauthorized": "Accès non autorisé",
    "not_found": "Ressource introuvable",
    "required": "Ce champ est obligatoire",
    "invalid_email": "Adresse email invalide",
    "invalid_format": "Format invalide",
    "min_length": "Minimum {{count}} caractères",
    "max_length": "Maximum {{count}} caractères",
    "try_again": "Réessayer",
    "contact_support": "Contacter le support",
    "no_data": "Aucune donnée disponible",
    "load_failed": "Échec du chargement",
    "save_failed": "Échec de la sauvegarde",
    "delete_failed": "Échec de la suppression",
    "label": "Erreur",
    "league_access_denied_title": "Accès refusé",
    "league_access_denied": "Cette ligue est hors de votre périmètre : vous n'avez pas accès à ses données disciplinaires.",
    "load_failed_description": "Les données n'ont pas pu être chargées. Réessayez dans un instant.",
    "module_access_denied": "Vous n'avez pas la permission d'accéder au module disciplinaire."
  },
  "notifications": {
    "success": "Succès",
    "error": "Erreur",
    "warning": "Avertissement",
    "info": "Information",
    "saved": "Sauvegardé avec succès",
    "deleted": "Supprimé avec succès",
    "updated": "Mis à jour avec succès",
    "created": "Créé avec succès",
    "exported": "Exporté avec succès",
    "imported": "Importé avec succès",
    "sent": "Envoyé avec succès",
    "copied": "Copié dans le presse-papiers",
    "save_failed": "Erreur lors de la sauvegarde."
  },
  "pagination": {
    "page": "Page",
    "of": "sur",
    "showing": "Affichage de",
    "to": "à",
    "results": "résultats",
    "total": "Total",
    "per_page": "Par page",
    "first": "Premier",
    "last": "Dernier",
    "no_results": "Aucun résultat",
    "rows_option": "{{count}} lignes",
    "page_of": "Page {{page}} sur {{total}}",
    "prev_label": "‹ Précédent",
    "next_label": "Suivant ›",
    "no_results_short": "Aucun résultat.",
    "select_placeholder": "Sélectionner...",
    "search_placeholder": "Rechercher..."
  },
  "confirm_delete": {
    "title": "Confirmer la suppression",
    "message": "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.",
    "confirm_text": "Supprimer",
    "cancel_text": "Annuler"
  },
  "empty_state": {
    "title": "Aucun élément",
    "description": "Il n'y a rien à afficher pour le moment.",
    "action": "Créer le premier élément"
  },
  "months": {
    "january": "Janvier",
    "february": "Février",
    "march": "Mars",
    "april": "Avril",
    "may": "Mai",
    "june": "Juin",
    "july": "Juillet",
    "august": "Août",
    "september": "Septembre",
    "october": "Octobre",
    "november": "Novembre",
    "december": "Décembre"
  },
  "days": {
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche"
  },
  "language": {
    "fr": "Français",
    "ar": "Arabe",
    "french": "Français",
    "arabic": "عربي",
    "switch_to_arabic": "Passer en arabe",
    "switch_to_french": "Passer en français"
  },
  "filters": {
    "all": "Tous",
    "active_filters": "Filtres actifs",
    "clear_filters": "Effacer les filtres",
    "no_filters": "Aucun filtre actif",
    "filter_by": "Filtrer par"
  },
  "table": {
    "actions": "Actions",
    "no_data": "Aucune donnée",
    "loading": "Chargement des données…",
    "label": "Tableau"
  },
  "error_boundary": {
    "title": "Coup de sifflet technique !",
    "subtitle": "L'arbitre a signalé une faute technique",
    "description": "Une erreur inattendue s'est produite",
    "detail": "Nous ne pouvons pas charger les données des officiels et des matchs pour le moment. Notre équipe technique a été notifiée et travaille sur la résolution du problème.",
    "refresh_btn": "Actualiser la page",
    "home_btn": "Retour à l'accueil",
    "help_text": "Si le problème persiste, contactez le support technique",
    "tips_title": "Conseils de dépannage",
    "tip_internet": "Vérifiez votre connexion internet",
    "tip_cache": "Essayez de vider le cache de votre navigateur",
    "tip_browser": "Assurez-vous d'utiliser la dernière version du navigateur",
    "tip_extensions": "Désactivez temporairement les extensions du navigateur"
  },
  "support": {
    "page_title": "Support & Assistance",
    "contact_title": "Contactez-nous",
    "faq_title": "Questions fréquentes",
    "guides_title": "Guides d'utilisation",
    "extra_help_title": "Besoin d'aide supplémentaire ?",
    "back_home_btn": "Retour à l'accueil",
    "footer_copyright": "© 2025 Moubarati - مباراتي. Tous droits réservés.",
    "guides_note_label": "Note:",
    "guides_note_text": "Les guides détaillés sont disponibles auprès de votre administrateur de ligue.",
    "contact_intro": "Pour toute question ou assistance, n'hésitez pas à nous contacter :",
    "extra_help_text": "Si vous ne trouvez pas la réponse à votre question dans cette page, ou si vous rencontrez un problème technique, veuillez contacter directement votre administrateur de ligue ou nous écrire à l'adresse email indiquée ci-dessus.",
    "faq": {
      "q1": "Comment puis-je accéder à mon planning d'arbitrage ?",
      "a1": "Connectez-vous à votre compte et accédez à la section 'Planning' depuis le menu principal. Vous y trouverez tous vos matchs assignés avec les détails complets.",
      "q2": "Comment gérer mes disponibilités ?",
      "a2": "Dans la section 'Arbitres', cliquez sur votre profil et accédez à l'onglet 'Disponibilités'. Vous pouvez y indiquer vos périodes d'indisponibilité.",
      "q3": "Où puis-je consulter mes paiements ?",
      "a3": "Les informations de paiement sont disponibles dans la section 'Finances'. Vous y trouverez l'historique de vos indemnités et l'état de vos paiements.",
      "q4": "Comment mettre à jour mes coordonnées bancaires (RIB) ?",
      "a4": "Contactez votre administrateur de ligue pour mettre à jour votre RIB. Les modifications bancaires doivent être validées pour garantir la sécurité des paiements.",
      "q5": "Que faire en cas d'erreur sur une assignation ?",
      "a5": "Contactez immédiatement votre administrateur de ligue via l'email indiqué ci-dessous. Les corrections peuvent être effectuées avant la validation finale.",
      "q6": "Comment consulter l'historique de mes missions ?",
      "a6": "Votre historique complet est disponible dans votre profil d'arbitre. Vous pouvez filtrer par saison, type de match, et voir toutes les statistiques détaillées."
    },
    "guides": {
      "guide1_title": "Guide de démarrage rapide",
      "guide1_desc": "Découvrez les fonctionnalités essentielles de la plateforme",
      "guide2_title": "Gestion des assignations",
      "guide2_desc": "Comprendre le système d'assignation des arbitres aux matchs",
      "guide3_title": "Système de paiement",
      "guide3_desc": "Tout savoir sur les indemnités et le processus de paiement"
    }
  },
  "privacy": {
    "page_subtitle": "Politique de confidentialité",
    "last_updated": "Dernière mise à jour / آخر تحديث : Juin 2026",
    "commitment_title": "Notre engagement",
    "section1_title": "1. Données collectées",
    "section1_personal": "Informations personnelles",
    "section1_activity": "Données d'activité",
    "section1_technical": "Données techniques",
    "section2_title": "2. Utilisation des données",
    "section3_title": "3. Sécurité des données",
    "section4_title": "4. Partage des données",
    "section5_title": "5. Vos droits",
    "right_access": "Droit d'accès",
    "right_rectification": "Droit de rectification",
    "right_erasure": "Droit à l'effacement",
    "right_portability": "Droit à la portabilité",
    "section6_title": "6. Cookies et technologies similaires",
    "section7_title": "7. Conservation des données",
    "section8_title": "9. Contact et réclamations",
    "section9_title": "10. Modifications de la politique",
    "back_home_btn": "Retour à l'accueil",
    "footer_copyright": "© 2026 Moubarati - مباراتي. Tous droits réservés.",
    "commitment_text": "Moubarati regroupe une plateforme web de gestion des officiels et trois applications mobiles : Moubarati Officiel, Moubarati Fans (Moubarati Live) et Moubarati Média. Nous nous engageons à protéger la confidentialité et la sécurité de vos données personnelles sur l'ensemble de ces produits. Cette politique explique quelles données nous collectons, comment nous les utilisons et comment nous les protégeons.",
    "section1_personal_items": [
      "Nom complet, prénom, date de naissance",
      "Coordonnées (email, téléphone, adresse)",
      "Informations d'identification (numéro de licence, catégorie d'arbitre)",
      "Coordonnées bancaires (RIB) pour le traitement des paiements",
      "Localisation géographique (Wilaya, Daira, Commune)"
    ],
    "section1_activity_items": [
      "Assignations aux matchs et missions",
      "Historique des performances et évaluations",
      "Disponibilités et indisponibilités déclarées",
      "Historique des paiements et indemnités",
      "Actions disciplinaires (le cas échéant)"
    ],
    "section1_technical_items": [
      "Adresse IP et informations de connexion",
      "Type de navigateur et appareil utilisé",
      "Données de session et cookies d'authentification",
      "Logs d'audit pour la sécurité et la conformité"
    ],
    "section2_intro": "Vos données personnelles sont utilisées exclusivement dans le cadre de la gestion des activités d'arbitrage et des opérations de la ligue :",
    "section2_items": [
      "Assignation des arbitres aux matchs et missions",
      "Calcul et traitement des indemnités de déplacement et d'arbitrage",
      "Gestion des disponibilités et planification des matchs",
      "Communication d'informations relatives aux assignations",
      "Génération de documents officiels (ordres de mission, états de paiement)",
      "Suivi disciplinaire et gestion des sanctions",
      "Audit et conformité réglementaire",
      "Amélioration des services de la plateforme",
      "Envoi de notifications (convocations, alertes, actualités) via les applications mobiles",
      "Localisation des stades lors des audits de terrain (application Officiel)",
      "Capture de preuves d'audit et de documents d'accréditation via l'appareil photo",
      "Diagnostic de stabilité et correction des erreurs des applications"
    ],
    "section3_intro": "Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données contre tout accès non autorisé, perte ou altération :",
    "section3_items": [
      {
        "label": "Chiffrement SSL/TLS",
        "text": "Toutes les communications sont chiffrées"
      },
      {
        "label": "Authentification sécurisée",
        "text": "Accès protégé par mot de passe et sessions sécurisées"
      },
      {
        "label": "Row Level Security (RLS)",
        "text": "Politiques de sécurité au niveau des données"
      },
      {
        "label": "Audit logs complets",
        "text": "Traçabilité de toutes les modifications"
      },
      {
        "label": "Hébergement sécurisé",
        "text": "Infrastructure Supabase conforme aux standards internationaux"
      },
      {
        "label": "Contrôle d'accès",
        "text": "Permissions basées sur les rôles et les ligues"
      }
    ],
    "section4_intro": "Vos données personnelles ne sont jamais vendues à des tiers. Elles peuvent être partagées uniquement dans les cas suivants :",
    "section4_items": [
      "Avec votre ligue d'affectation pour la gestion des assignations",
      "Avec les institutions bancaires pour le traitement des paiements (RIB uniquement)",
      "Avec les fournisseurs de services techniques (Supabase) dans le cadre de l'hébergement sécurisé",
      "Sur demande des autorités légales compétentes (obligation légale)"
    ],
    "section5_intro": "Conformément à la réglementation en vigueur, vous disposez des droits suivants :",
    "right_access_desc": "Consulter vos données personnelles stockées dans la plateforme",
    "right_rectification_desc": "Corriger les informations inexactes ou incomplètes",
    "right_erasure_desc": "Demander la suppression de vos données (sous réserve d'obligations légales)",
    "right_portability_desc": "Recevoir vos données dans un format structuré",
    "rights_contact": "Pour exercer vos droits, contactez-nous à :",
    "section6_intro": "Nous utilisons des cookies et technologies similaires pour :",
    "section6_items": [
      "Maintenir votre session d'authentification sécurisée",
      "Mémoriser vos préférences (langue, affichage)",
      "Analyser l'utilisation de la plateforme pour l'améliorer"
    ],
    "section6_note": "Les cookies essentiels sont nécessaires au fonctionnement de la plateforme et ne peuvent être désactivés.",
    "section7_intro": "Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, et conformément aux obligations légales :",
    "section7_items": [
      "Données d'arbitrage actif : pendant votre activité + 3 ans d'archive",
      "Historique financier : 10 ans (obligations comptables)",
      "Données disciplinaires : durée réglementaire selon le type de sanction",
      "Logs d'audit : 5 ans minimum pour la conformité"
    ],
    "section8_intro": "Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits :",
    "section8_email_label": "Email :",
    "section8_response_note": "Nous nous engageons à répondre à toute demande dans un délai de 30 jours.",
    "section9_text": "Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute modification significative sera communiquée via la plateforme ou par email.",
    "section9_last_updated": "Date de dernière mise à jour : Juin 2026",
    "section1_intro": "Moubarati regroupe quatre produits : la plateforme web de gestion des officiels et trois applications mobiles (Moubarati Officiel, Moubarati Fans et Moubarati Média). La plateforme web et les comptes utilisateurs collectent les données communes décrites ci-dessous ; chaque application mobile ajoute les données indiquées dans sa fiche. Les données de licence, RIB, discipline et historique de paiement décrites ci-dessous ne concernent que les officiels.",
    "section1_common_title": "Données communes (plateforme web et comptes)",
    "section1_apps_title": "Données spécifiques aux applications mobiles",
    "apps": [
      {
        "name": "Moubarati Officiel (application des officiels)",
        "data": [
          "Localisation GPS précise : utilisée uniquement lors des audits de stade, après votre consentement explicite",
          "Appareil photo et photos : capture de preuves photographiques lors des audits de stade",
          "Jeton de notification push (via Google FCM / Apple APNs) pour vous envoyer convocations et alertes",
          "Informations sur l'appareil (modèle, système d'exploitation, version de l'application)",
          "Diagnostics de plantage et d'erreur via Sentry, pour la stabilité de l'application",
          "Stockage local sécurisé de votre jeton d'authentification sur l'appareil"
        ]
      },
      {
        "name": "Moubarati Fans (Moubarati Live)",
        "data": [
          "Compte et coordonnées (email, identifiant)",
          "Jeton de notification push (via Google FCM / Apple APNs) pour les actualités et alertes de match",
          "Informations sur l'appareil (modèle, système d'exploitation, version de l'application)",
          "Photo de profil facultative que vous choisissez d'ajouter",
          "Stockage local de votre session sur l'appareil"
        ]
      },
      {
        "name": "Moubarati Média (accréditation média)",
        "data": [
          "Identité et données de la demande d'accréditation (nom, organe de presse, fonction)",
          "Appareil photo et photos : capture de documents et de photos d'identité pour l'accréditation",
          "Le microphone peut être sollicité par le module appareil photo ; aucun enregistrement audio n'est conservé",
          "Stockage local des données de demande sur l'appareil"
        ]
      }
    ],
    "section4_processors_intro": "Nous faisons appel à des prestataires techniques (sous-traitants) qui traitent les données pour notre compte, sans jamais les revendre :",
    "section4_processors": [
      {
        "label": "Supabase",
        "text": "Hébergement de la base de données, authentification et stockage des fichiers"
      },
      {
        "label": "Expo, Google FCM et Apple APNs",
        "text": "Acheminement des notifications push vers votre appareil"
      },
      {
        "label": "Sentry",
        "text": "Diagnostics de plantage et d'erreur (application Officiel uniquement)"
      },
      {
        "label": "SendGrid",
        "text": "Envoi des emails transactionnels (confirmations, réinitialisations)"
      }
    ],
    "deletion_title": "8. Suppression du compte et des données",
    "deletion_intro": "Vous pouvez demander la suppression de votre compte et de vos données personnelles à tout moment, sans avoir à installer l'application :",
    "deletion_items": [
      "Envoyez votre demande par email à lirf@moubarati.com avec l'objet « Suppression de compte »",
      "Indiquez l'adresse email associée à votre compte et l'application concernée (Officiel, Fans ou Média)",
      "Vos données personnelles seront supprimées dans un délai maximum de 30 jours après vérification de votre identité"
    ],
    "deletion_retained_note": "Certaines données peuvent être conservées lorsque la loi l'exige, notamment l'historique financier (10 ans) et les journaux d'audit (5 ans), même après la suppression de votre compte.",
    "section6_mobile_note": "Les applications mobiles n'utilisent pas de cookies ; elles ne stockent que les informations de session nécessaires, localement sur votre appareil."
  },
  "yes": "Oui",
  "no": "Non",
  "no_team": "Aucune équipe",
  "values": {
    "not_available": "N/A"
  },
  "season_readonly": {
    "banner": "Saison archivée — lecture seule",
    "super_admin_hint": "Édition réservée au super-administrateur",
    "blocked": "Action indisponible : la saison est archivée"
  },
  "season_not_live": {
    "banner": "Saison {{season}} pas encore activée : les données restent incomplètes tant que la transition n'est pas terminée.",
    "go_to_transition": "Aller à la transition",
    "empty_title": "Saison non activée",
    "empty_desc": "Terminez la transition de saison pour générer les données de cette saison.",
    "status_not_started": "La transition de saison n'est pas encore lancée.",
    "status_ongoing": "Transition de saison en cours (étape {{done}}/{{total}}).",
    "league_hint": "Vous pourrez configurer vos groupes et calendriers une fois la transition terminée.",
    "view_board": "Voir la préparation de la saison"
  },
  "job_center": {
    "calendar_recover_title": "Sauvegarder le résultat comme candidat",
    "calendar_recover_done_title": "Résultat déjà enregistré comme candidat",
    "calendar_open_title": "Voir le calendrier optimisé (ouvrir le groupe)",
    "calendar_recovered_label": "Candidat {{n}} — optimisé — {{date}} (récupéré)",
    "calendar_recover_done": "Résultat enregistré : {{label}}",
    "calendar_recover_exists": "Ce résultat est déjà enregistré comme candidat.",
    "calendar_recover_empty": "Aucun résultat exploitable sur ce job.",
    "calendar_recover_no_season": "Saison du groupe introuvable — impossible d'enregistrer le candidat.",
    "calendar_recover_failed": "Échec de l'enregistrement du candidat.",
    "stop_title": "Arrêter l'optimisation",
    "retry_title": "Relancer (crée une nouvelle tâche)",
    "stop_confirm_title": "Arrêter l'optimisation ?",
    "stop_confirm_body": "Le solveur s'interrompt sous peu (jusqu'à la limite de temps). La tâche sera marquée annulée.",
    "stop_confirm_btn": "Arrêter",
    "view": "Voir"
  },
  "stadium_select": {
    "placeholder": "Choisir un stade…",
    "search": "Rechercher un stade, une commune, une wilaya…",
    "no_location": "Sans localisation",
    "no_coords": "Pas de coordonnées",
    "group_league": "Stades de la ligue",
    "group_other": "Autres stades"
  },
  "maintenance": {
    "title": "Application en maintenance",
    "default_message": "L'application est temporairement indisponible pour maintenance. Merci de réessayer un peu plus tard.",
    "expected_end": "Reprise prévue : {{date}}",
    "retry": "Réessayer",
    "sign_out": "Se déconnecter",
    "banner_title": "Maintenance active",
    "banner_scopes": "Apps concernées : {{scopes}}",
    "banner_writes_blocked": "écritures bloquées",
    "banner_manage": "Gérer",
    "scopes": {
      "web": "Webapp",
      "officiels": "App Officiels",
      "fans": "App Fans",
      "media": "App Média"
    }
  },
  "categories": {
    "filter_label": "Catégorie",
    "all": "Toutes"
  },
  "cup": {
    "round_label": "Tour",
    "round_unknown": "Tour non précisé",
    "game_day": "Journée {{n}}",
    "game_day_short": "J{{n}}"
  }
}
